import ImagePlaceholder from "@/components/base/ImagePlaceholder";

const avantages = [
  "Ouverture et fermeture sans effort, d'un simple geste",
  "Programmation horaire : le volet s'ouvre et se ferme automatiquement",
  "Pilotage à distance depuis une télécommande ou votre smartphone",
  "Simulation de présence pour plus de sécurité pendant vos absences",
  "Fonctionnement silencieux et fluide grâce aux moteurs Somfy",
  "Gain de temps et d'énergie au quotidien, sans modifier le volet",
];

export default function Avantages() {
  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="order-2 lg:order-1">
            <h2 className="text-brand-blue text-2xl md:text-3xl font-extrabold mb-5">
              Avantages au quotidien
            </h2>
            <p className="text-brand-text text-base leading-relaxed mb-5">
              Passer vos volets manuels en électrique Somfy change radicalement votre quotidien. Plus besoin de tirer sur la sangle ou de tourner la manivelle : un simple appui sur une télécommande suffit pour ouvrir ou fermer tous vos volets simultanément. Vous gagnez un temps précieux le matin et le soir, et vous évitez les efforts répétitifs, surtout sur les volets de grande taille ou situés en hauteur.
            </p>
            <p className="text-brand-text text-base leading-relaxed mb-6">
              La programmation horaire vous permet d'automatiser les heures d'ouverture et de fermeture selon vos habitudes. Vous pouvez aussi activer la simulation de présence pendant vos vacances, pour dissuader les intrusions. Avec les commandes connectées io-homecontrol, vous pilotez vos volets depuis votre smartphone, même à distance. Chaque moteur Somfy est conçu pour un fonctionnement silencieux et durable, sans vibrations ni à-coups.
            </p>
            <ul className="space-y-3 mb-8">
              {avantages.map((avantage) => (
                <li key={avantage} className="flex items-start gap-3">
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-brand-cyan/10 shrink-0 mt-0.5">
                    <i className="ri-check-line text-brand-cyan text-sm"></i>
                  </span>
                  <span className="text-brand-text text-base">{avantage}</span>
                </li>
              ))}
            </ul>

            <a
              href="tel:0374473240"
              className="flex items-center justify-center gap-2 bg-brand-cyan text-white px-6 py-4 rounded-full font-semibold text-base hover:bg-brand-cyan/90 transition-all duration-200 btn-hover-effect whitespace-nowrap mx-auto"
            >
              <span className="btn-icon-wrap"><i className="ri-phone-line text-lg"></i></span>
              Appeler le 03 74 47 32 40
            </a>
          </div>

          <div className="order-1 lg:order-2 relative rounded-xl overflow-hidden border border-brand-border">
            <ImagePlaceholder src="https://readdy.ai/api/search-image?query=Modern%20French%20living%20room%20with%20a%20motorized%20Somfy%20roller%20shutter%20being%20controlled%20by%20a%20remote%20from%20a%20comfortable%20sofa%20warm%20interior%20lighting%20cozy%20atmosphere%20clean%20professional%20photography%20neutral%20tones%20Alsace%20home&width=700&height=520&seq=elec-avant&orientation=landscape" alt="Volet Somfy motorisé commandé par télécommande depuis un canapé" className="w-full h-[340px] md:h-[420px]" loading="lazy" />
          </div>
        </div>
      </div>
    </section>
  );
}